import request from '../../../config/Request'

const device = {
    deviceTacticsQueryList:'/api/DeviceTactics/queryList',// 查询设备告警策略列表
    deviceTacticsQueryDetail:'/api/DeviceTactics/queryDetail',// 查询设备告警策略详细
    deviceTacticsEditDetail:'/api/DeviceTactics/editDetail',// 编辑设备告警策略
    deviceTacticsDelDetail:'/api/DeviceTactics/delDetail',// 删除设备告警策略
};
/**
 * 查询设备告警策略列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getDeviceTacticsQueryList(parameter) {
    return request({
        url: device.deviceTacticsQueryList,
        data: parameter
    })
}
/**
 * 编辑设备告警策略
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function deviceTacticsEditDetail(parameter) {
    return request({
        url: device.deviceTacticsEditDetail,
        data: parameter
    })
}
/**
 * 删除设备告警策略
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function deviceTacticsDelDetail(parameter) {
    return request({
        url: device.deviceTacticsDelDetail,
        data: parameter
    })
}
